<template>
    <div>
        <nsw-banner ref="nsw"></nsw-banner>
        <nsw-menu></nsw-menu>
        <div class="content-wrapper">
            <nsw-module></nsw-module>
            <nsw-news></nsw-news>
        </div>
    </div>
</template>
<script>

    import Vue from 'vue';
    import axios from 'axios';
    import api from '@js/api';
    import router from '@js/routes';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import {mapState, mapGetters} from 'vuex';
    import EventBus from '@common/eventBus';
    import {checkViewCount} from '@mixins/checkViewCount';


    export default {
        name:"Home",
        mixins:[common,storeMapper, checkViewCount],
        beforeRouteEnter (to, from, next) {
            next(vm=>{
                EventBus.$emit("showGlobalLoading");

                Promise.all(
                    [
                        api.getMainCate(),
                        api.getBanner(),
                        api.getDownloadData(),
                        api.getMpmsSystemMsg(mpms_get_system_msg_url),
                        api.getWebsitePopup()
                    ]
                //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                //If something has to be processed when error returns, place the logic in catch block instead
                .map(p => p.catch(() => undefined)))
                .then(axios.spread((responseMainCate, responseBanner, responseDownloadData, mpms_resp, popup_resp) => {

                        if (responseMainCate) {
                            vm.setWebSiteAndCate( responseMainCate.data, vm);
                        }
                        if (responseBanner) {
                            vm.$store.commit('banner/setBanner', responseBanner.data);
                        }

                        if (responseDownloadData) {
                            vm.$store.commit("my_download_store/updateData", responseDownloadData.data);

                            responseDownloadData.data.zip_list.forEach(function(item) {
                                if (!item.finished_zip) {
                                    let id = item.id.$oid;
                                    EventBus.$emit("checkDownloadStatus", id);
                                }
                            });
                        }

                        if (mpms_resp) {
                            if (mpms_resp.data.length > 0) {

                                if (vm.isShowPopup(mpms_popup_id)) {
                                    let msg = [];
                                    mpms_resp.data.forEach(function(item) {

                                        if (item.msg) {
                                            item.msg.forEach(function(obj) {
                                                if (obj.lang === website_lang) {
                                                    msg.push(obj.txt);
                                                }
                                            });
                                        }

                                    });

                                    EventBus.$emit("showHkepMsgPop", msg);

                                    vm.initViewCount(mpms_popup_id);

                                }

                            }

                        }

                        if (popup_resp) {
                            if (popup_resp.data) {
                                EventBus.$emit("show_hkep_popup", popup_resp.data[0]);

                            }
                        }

                        vm.$refs.nsw.startCarousel();

                        //TODO: Handle MathJax in common  place, e.g. mixins
                        Vue.nextTick(()=>{
                            if(window.MathJax) {
                                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => {
                                    EventBus.$emit("hideGlobalLoading");
                                });
                            }
                        });

                    }))
                    /*.catch(error=>{
                        //Handle errors here if something is expected to precess here
                    });
                    */
                })

        },
        computed: {

        },
        mounted() {

            var content_wrapper = document.getElementsByClassName("content-wrapper");
            if (content_wrapper) {
                content_wrapper[0].style.minHeight = window.innerHeight-170+"px";
            }

            window.onresize = function(event) {

                if (content_wrapper) {
                    content_wrapper[0].style.minHeight = window.innerHeight-170+"px";
                }
            };

        }

    }
</script>

<style scoped lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";


</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Home.vue